import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20digital%20texture%20with%20soft%20grainy%20noise%2C%20minimal%20art%20photography%2C%20gentle%20amber%20and%20warm%20beige%20gradient%20with%20organic%20flowing%20lines%2C%20vintage%20film%20grain%20effect%2C%20artistic%20abstract%20background%2C%20no%20text%20or%20objects&width=1600&height=600&seq=cta-bg-51nav&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/70 to-foreground-900/30"></div>

          <div className="relative z-10 py-16 md:py-24 text-center px-6">
            <h2 className="font-heading font-bold text-3xl md:text-5xl text-background-50 leading-tight">
              还没有找到你想要的网站？
              <br />
              <span className="italic text-background-300">试试我们的智能搜索</span>
            </h2>
            <p className="mt-6 text-background-300 text-base max-w-lg mx-auto">
              百万网址库，一秒精准直达。无论是<strong className="text-background-50">网址导航大全</strong>、
              <strong className="text-background-50">吃瓜爆料</strong>还是
              <strong className="text-background-50">各类网站导航</strong>，都能快速找到。
            </p>
            <div className="mt-8 flex items-center justify-center">
              <Link
                to="/category/yingshi"
                className="whitespace-nowrap px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-label font-semibold text-sm hover:bg-accent-600 transition-colors cursor-pointer"
              >
                立即探索
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}